<!--
 * @Author: Lemon C
 * @Date: 2024-06-07 13:38:34
 * @LastEditTime: 2025-01-17 16:33:16
-->
<template>
    <div class="sup-func-detail">
        <div class="re-w1200 re-main-col">
            <div class="func-msg-box">
                <div class="f-m-left-box">
                    <span class="f-m-l-title">{{ func_data.coverTitle }}</span>
                    <div class="f-m-l-line"></div>
                    <div class="f-m-l-dis">
                        {{ func_data.details ? func_data.details.description : '' }}
                    </div>
                    <div class="f-m-l-btn-box">
                        <el-button
                            v-if="func_data.details && func_data.details.courseAddress && func_data.details.courseAddress.length"
                            type="primary"
                            @click="show_course_click"
                            >查看教程</el-button
                        >
                        <el-button
                            v-if="func_data.details && func_data.details.sourceCodePath && func_data.details.sourceCodePath.length"
                            type="primary"
                            @click="down_proj_click"
                            >下载项目</el-button
                        >
                        <el-button
                            v-if="func_data.details && func_data.details.demoAddress && func_data.details.demoAddress.length"
                            type="primary"
                            @click="show_demo_click"
                            >查看Demo</el-button
                        >
                    </div>
                </div>
                <div class="f-m-right-box">
                    <div
                        v-if="vedio_page_list_first_item_computed"
                        class="f-m-right-video"
                        @click="vedio_grid_item_click(vedio_page_list_first_item)">
                        <re-img
                            class="f-m-right-video-top-cover"
                            :src="downloadBaseUrl_computed(vedio_page_list_first_item.videoCoverPath)"
                            :ph="require(`@/assets/imgs/product/placeholder_bg.png`)"></re-img>
                        <img class="f-m-right-video-top-play" src="@/assets/imgs/product/icon_vedio_play.png" />
                    </div>
                    <re-img
                        v-if="!vedio_page_list_first_item_computed"
                        class="f-m-right-img"
                        :src="downloadBaseUrl_computed(func_data.details ? func_data.details.descriptionImgPath : '')"
                        :ph="require(`@/assets/imgs/product/placeholder_bg.png`)"></re-img>
                </div>
            </div>
            <div class="func-video-box" v-if="func_data.details && func_data.details.videos && func_data.details.videos.length > 1">
                <span class="f-v-title">视频</span>
                <div class="f-v-line"></div>
                <div class="f-v-cont-box">
                    <!-- <img class="change-btn" src="@/assets/imgs/general/icon_jump_left.png" alt="Left" @click="vedio_scrollGrid('left')" /> -->
                    <div class="grid-list-box" ref="ref_f_v_list_box">
                        <div class="grid-page-box" v-for="(page, pageIndex) in vedio_page_list_computed" :key="`page_${pageIndex}`">
                            <div
                                class="grid-item-box"
                                v-for="(item, index) in page.gridList"
                                :key="`item_${pageIndex}_${index}`"
                                @click="vedio_grid_item_click(item)">
                                <div class="grid-item-top-box">
                                    <re-img
                                        class="grid-item-top-cover"
                                        :src="downloadBaseUrl_computed(item.videoCoverPath)"
                                        :ph="require(`@/assets/imgs/product/placeholder_bg.png`)"></re-img>
                                    <img class="grid-item-top-play" src="@/assets/imgs/product/icon_vedio_play.png" />
                                </div>
                                <span>{{ item.videoName }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- <img class="change-btn" src="@/assets/imgs/general/icon_jump_right.png" alt="Right" @click="vedio_scrollGrid('right')" /> -->
                </div>
            </div>
            <NextProduct
                class="next-product"
                :comp_curr_product_id="func_introduce_id"
                :comp_product_list="function_list"
                :comp_next_jump_callback="comp_next_jump_callback" />
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, onMounted, getCurrentInstance, computed, nextTick } from 'vue';
import { getEngineFunctionDetail, getEngineFunctionList } from '@/service/interface';
import NextProduct from '@/components/Product/NextProduct.vue';
import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '../../stores/message';
import { useDialogStore } from '@/stores/dialog';

const dialog_store = useDialogStore();
const message_store = useMessageStore();
const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const ref_f_v_list_box = ref(null);
const func_introduce_id = ref('');
const func_data = ref({});
const function_list = ref([]); //功能列表
const video_grid_perPage = ref(3); // 每页显示的项目数 (1行 * 3列)
const video_show_count = ref(3); // 当前显示数量
const vedio_page_list_first_item = ref({}); // 第一个视频资源

const vedio_page_list_computed = computed(() => {
    const pages = [];
    if (!func_data.value.details) return pages;
    let pageInde = 0;
    for (let i = 0; i < video_show_count.value; i += video_grid_perPage.value) {
        pages.push({ gridList: func_data.value.details.videos.slice(i, i + video_grid_perPage.value), pageIndex: pageInde });
        pageInde++;
    }
    return pages;
});

const vedio_page_list_first_item_computed = computed(() => {
    if (func_data.value.details && func_data.value.details.videos && func_data.value.details.videos.length == 1) {
        vedio_page_list_first_item.value = func_data.value.details.videos[0];
        return true;
    } else {
        return false;
    }
});

const downloadBaseUrl_computed = computed(() => (path) => {
    let url = '';
    if (path && path.length) {
        url = `${window.downloadBaseUrl}/${path}`;
    }
    return url;
});

onBeforeMount(() => {
    let queryDate = proxy.$route.query;
    if (queryDate && queryDate.id && queryDate.id.length > 0) {
        func_introduce_id.value = queryDate.id;
    }
});

onMounted(() => {
    service_get_funcDetail();
    service_engine_fun_list();
});

// MARK Service 获取功能介绍列表
const service_engine_fun_list = () => {
    proxy.$showLoading();
    getEngineFunctionList().then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            function_list.value = res.data;
        }
    });
};

// MARK Service 获取功能介绍详情
const service_get_funcDetail = () => {
    proxy.$showLoading();
    getEngineFunctionDetail(func_introduce_id.value).then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            func_data.value = res.data;
        }
        message_store.sendMessage(message_store.M_E_SCROLL_TOP, false);
    });
};

// MARK Scroll 分页滚动
const vedio_scrollGrid = (direction) => {
    const pageWidth = ref_f_v_list_box.value.clientWidth;
    if (direction === 'left') {
        ref_f_v_list_box.value.scrollBy({ left: -pageWidth, behavior: 'smooth' });
    } else if (direction === 'right') {
        ref_f_v_list_box.value.scrollBy({ left: pageWidth, behavior: 'smooth' });
    }
};

// MARK Click 查看教程
const show_course_click = () => {
    router_store.navigateToLinkHref(func_data.value.details.courseAddress);
};

// MARK Click 下载项目
const down_proj_click = () => {
    window.open(`${window.downloadBaseUrl}/${func_data.value.details.sourceCodePath}`, '_blank');
};

// MARK Click 查看Demo
const show_demo_click = () => {
    router_store.navigateToLinkHref(func_data.value.details.demoAddress);
};

// MARK Grid 点击事件
const vedio_grid_item_click = (item) => {
    if (!item.videoPath.length) {
        proxy.$message.error('视频链接缺失，打开失败！');
        return;
    }
    if (item.videoPath.includes('Videos') && !item.videoPath.includes('http')) {
        // 视频文件
        dialog_store.showVideoDialog(item.videoPath);
    } else {
        // B站链接
        window.open(item.videoPath, '_blank');
    }
};

// MARK Click 上下一篇
const comp_next_jump_callback = (id) => {
    func_introduce_id.value = id;
    service_get_funcDetail();
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-func-detail {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;

    .func-msg-box {
        position: relative;
        width: 100%;
        margin-top: 48px;
        display: flex;
        overflow: hidden;

        .f-m-left-box {
            position: relative;
            display: flex;
            flex-direction: column;
            flex: 1;
            height: 100%;

            .f-m-l-title {
                position: relative;
                height: 60px;
                font-size: 40px;
                font-weight: 500;
                color: var(--color-main-text-primary);
            }

            .f-m-l-line {
                position: relative;
                margin-top: 20px;
                width: 73px;
                height: 7px;
                background: var(--color-main-brand);
                border-radius: 1px;
            }

            .f-m-l-dis {
                position: relative;
                margin-top: 40px;
                margin-bottom: 60px;
                width: 100%;
                flex: 1;
                font-weight: 400;
                font-size: 20px;
                color: var(--color-main-text-secondary);
                line-height: 39px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                // -webkit-line-clamp: 4;
                /* 显示的最大行数 */
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
            }

            .f-m-l-btn-box {
                position: relative;
                margin-bottom: 0px;
                display: flex;
                flex-shrink: 0;

                .el-button {
                    position: relative;
                    margin-right: 33px;
                    width: 146px;
                    height: 46px;
                    background: var(--color-main-brand);
                    font-size: var(--font-elbtn-title-size20);
                    border-radius: 4px;
                }
            }
        }

        .f-m-right-box {
            position: relative;
            margin-top: 135px;
            margin-left: 80px;
            width: 440px;
            height: 260px;
            display: flex;
            flex-shrink: 0;
            border-radius: 8px;
            overflow: hidden;

            .f-m-right-img {
                position: relative;
                width: 100%;
                height: 100%;
            }

            .f-m-right-video {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                cursor: pointer;

                .f-m-right-video-top-cover {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .f-m-right-video-top-play {
                    position: absolute;
                    top: 40%;
                    left: 50%;
                    width: 56px;
                    height: 56px;
                    transform: translate(-50%);
                    opacity: 0.82;
                    transition: var(--animation-opacity-style);
                }

                &:hover .f-m-right-video-top-play {
                    opacity: 1;
                }
            }
        }
    }

    .func-video-box {
        position: relative;
        width: 100%;
        margin-top: 80px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .f-v-title {
            position: relative;
            font-weight: 500;
            height: 60px;
            font-size: 40px;
            color: var(--color-main-text-primary);
        }

        .f-v-line {
            position: relative;
            margin-top: 20px;
            width: 73px;
            height: 7px;
            background: var(--color-main-brand);
            border-radius: 1px;
        }

        .f-v-cont-box {
            position: relative;
            margin-top: 53px;
            width: 100%;
            display: flex;
            align-items: center;

            .change-btn {
                position: relative;
                margin-top: -50px;
                width: 68px;
                height: 58px;
                cursor: pointer;
                flex-shrink: 0;
            }

            .grid-list-box {
                position: relative;
                display: flex;
                overflow: hidden;
                // overflow-x: scroll;
                // scroll-snap-type: x mandatory;
                flex: 1;

                .grid-page-box {
                    position: relative;
                    width: 100%;
                    flex-shrink: 0;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    column-gap: 90px;
                    scroll-snap-align: start;

                    .grid-item-box {
                        position: relative;
                        display: flex;
                        height: 280px;
                        align-items: center;
                        cursor: pointer;
                        overflow: hidden;
                        flex-direction: column;

                        .grid-item-top-box {
                            position: relative;
                            width: 340px;
                            height: 220px;
                            border-radius: 8px;
                            overflow: hidden;

                            .grid-item-top-cover {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }

                            .grid-item-top-play {
                                position: absolute;
                                top: 40%;
                                left: 50%;
                                width: 56px;
                                height: 56px;
                                transform: translate(-50%);
                                opacity: 0.82;
                                transition: var(--animation-opacity-style);
                            }
                        }

                        span {
                            position: relative;
                            margin-top: 33px;
                            height: 25px;
                            font-weight: 400;
                            font-size: 17px;
                            color: var(--color-main-text-secondary);
                        }

                        &:hover .grid-item-top-play {
                            opacity: 1;
                        }
                    }
                }

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }
    }

    .next-product {
        margin-top: 64px;
    }
}
</style>
